<script>
export default {
  name: 'Panels',
  props: {
    meetingName: {
      type: String,
      required: true,
      default: null,
    },
    racingEvents: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  computed: {
    processedRacingEvents() {
      return this.racingEvents.map(({ number, selections, url }) => {
        const gearChanges = this.describeGearChanges({ selections });
        return {
          eventLink: url,
          number: number,
          gearChanges,
        };
      });
    },
  },
  methods: {
    describeGearChanges: function({ selections = [], fallback = '-' }) {
      const hadGearChanges = selections.length > 0;
      if (!hadGearChanges) return fallback;
      let description = '';
      selections.forEach(({ number, gearChanges }) => {
        if (number && gearChanges) {
          description += `${number} ${gearChanges} `;
        }
      });
      return description;
    },
  },
};
</script>

<template>
  <div class="panel-component">
    <div class="panel-component__header">
      <h5 class="panel-component__title">{{ meetingName }}</h5>
    </div>
    <div class="panel-component__main">
      <div v-for="(event, index) in processedRacingEvents"
           :key="`event-link-`+index"
           class="panel-component__list"
      >
        <a :href="event.eventLink" class="panel-component__link">
          <span class="panel-component__race-number">race {{ event.number }}</span>
          <span class="panel-component__main-content">{{ event.gearChanges }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
